import { render, staticRenderFns } from "./Servis.vue?vue&type=template&id=aca1ef54&"
import script from "./Servis.vue?vue&type=script&lang=js&"
export * from "./Servis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports